<template lang="pug">
div
  ul.nav.navbar-nav.navbar-right
    li.dropdown(:class="{open: showLanguage}")
      a.dropdown-toggle(href="#" @click="toggleDropDown()" v-tooltip.bottom="lang['Change language']")
        span.flag.pl(v-if="lang.lang==='pl'")
        span.flag.en(v-if="lang.lang==='en'")
        span.caret
      ul.dropdown-menu.navbar-default
        li(v-if="lang.lang==='pl'")
          a(href="#" @click="changeLanguage('en')")
            span.flag.en
        li(v-else)
          a(href="#" @click="changeLanguage('pl')")
            span.flag.pl
    router-link(v-if="$store.getters.isUserAuthenticated && $store.getters.hasRole(['admin'])" to="/usercreate" tag="li" active-class="inactive")
      a(v-tooltip.bottom="lang['Add use']")
        i.fa.fa-lg.fa-user-plus
    router-link(v-if="$store.getters.isUserAuthenticated && $store.getters.hasRole(['admin'])" to="/userlist" tag="li" active-class="inactive")
      a(v-tooltip.bottom="lang['Users list']")
        i.fa.fa-lg.fa-user
    router-link(v-if="$store.getters.isUserAuthenticated && $store.getters.hasRole(['admin'])" to="/networklist" tag="li" active-class="inactive")
      a(v-tooltip.bottom="lang['Networks list']")
        i.fa.fa-lg.fa-network-wired
    li
      a(href="#" @click.prevent="logout()" v-tooltip.bottom="lang['Logout']")
        i.fa.fa-lg.fa-sign-out-alt
  p.navbar-text.navbar-right {{this.$store.getters.user.nick}}
</template>

<script>
export default {
  name: 'userNavigation',
  props: ['lang'],
  data () {
    return {
      showLanguage: false
    }
  },
  methods: {
    changeLanguage (langChangeTo) {
      this.$store.commit('SET_LOADER', true)
      this.$http.post('user/changeLanguage', {langChangeTo})
        .then(response => {
          if (response.status === 200) {
            window.location.reload()
          } else {
            this.$notify('Błąd', 'error')
          }
        })
    },
    toggleDropDown () {
      this.showLanguage = !this.showLanguage
    },
    logout () {
      this.$http.get('user/logout')
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (process.env.NODE_ENV !== 'production') {
            console.log(data)
          }
          if (data === 'logged out') {
            let cookies = document.cookie.split(';')

            for (var i = 0; i < cookies.length; i++) {
              var cookie = cookies[i]
              var eqPos = cookie.indexOf('=')
              var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
              document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
            }

            window.location.href = '/'
          }
        })
    }
  }
}
</script>
<style lang="sass">
.flag
  display: inline-block
  width: 32px
  height: 20px
  background-size: contain
  background-repeat: no-repeat
  &.pl
    background-image: url('/static/pl.png')
  &.en
    background-image: url('/static/gb.png')
</style>



// WEBPACK FOOTER //
// src/components/user/UserNav.vue